export default {
  id: 'teams_collective_goal',
  title: 'Collective goal',
  type: 'Group',
  description: 'Current status of the collective goal.',
  body: `<div>
    <p>[[INPUT_INTRODUCTION_TEXT]]</p>
    <p style="font-size: 16px; margin-top: 5px; margin-bottom: 10px;">{{COLLECTIVE_GOAL_ICON}} <strong>{{COLLECTIVE_GOAL_HEADLINE}}</strong></p>
    <p style="margin-top: 5px; margin-bottom: 10px;"><strong>{{COLLECTIVE_GOAL_PROGRESS}} {{COLLECTIVE_GOAL_FIRST_LINE}}</strong> {{COLLECTIVE_GOAL_SECOND_LINE}}</p>
    <table style="border:0; border-radius: 5px; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; overflow: hidden" cellpadding="0" cellspacing="0" width="100%">
      <tr style="padding:10px 25px">
        <td bgcolor="#007bff" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width:{{COLLECTIVE_GOAL_PERCENTAGE}}%; background-color:#007bff; float:left; height:15px;"></td>
        <td bgcolor="#cccccc" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width:{{COLLECTIVE_GOAL_PERCENTAGE_REMINDER}}%; background-color:#cccccc; float:left; height:15px;"></td>
      </tr>
    </table>
    <p>[[INPUT_END_TEXT]]</p>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>Please find the current status of our collective goal below.</p>',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text after collective goal',
      type: 'HTML',
      placeholder: 'Thanks for your support!',
      defaultValue: '<p>Do not forget that every activity on the platform gets us closer to reach our goal together.</p><p>If you have any questions please let me know.</p>',
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/collectiveGoal.js